import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import SiteLogo from "../SiteLogo";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./HeaderFigma.css";
import {
  AccountCircle,
  AddShoppingCart,
  Favorite,
  FavoriteBorder,
  Menu,
  Search,
  ShoppingCart,
} from "@mui/icons-material";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import MobileLinks from "./MobileLinks";
import { useTranslation } from "react-i18next";
import { Offcanvas } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useSearch } from "../Context/SearchContext";
import { useAuth } from "../Context/AuthContext";
import UserProfileContext from "../Context/UserProfileContext";
import { LikedProductContext } from "../Context/LikedProductContext";
import { CartContext } from "../Context/CartContext";
import { useCategory } from "../Context/CategoryContext";
import LoginModel from "./models/LoginModel";
import ForgotPasswordModel from "./models/ForgotPasswordModel";
import RegisterModal from "./models/RegisterModel";
import LanguageSwitcher from "../locales/LanguageSwitcher";
import NavbarWithDropdown from "./NavbarWithDropdown";
import {
  FaUser,
  FaInfoCircle,
  FaHeadset,
  FaQuestionCircle,
  FaFileContract,
  FaUndo,
  FaExchangeAlt,
  FaPhoneAlt,
  FaShoppingBag,
  FaSmile,
  FaSignOutAlt,
  FaSignInAlt,
  FaUserPlus,
} from "react-icons/fa";

const HeaderFigma = () => {
  const [showMedicineMenu, setShowMedicineMenu] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [showTabletsMenu, setShowTabletsMenu] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    const offcanvasElement = document.getElementById("mobileMenu");
    if (offcanvasElement) {
      const bsOffcanvas = Offcanvas.getInstance(offcanvasElement);
      bsOffcanvas.hide();
    }
    navigate(path); // Navigate after closing drawer
  };

  //old Navbar functions

  const { userProfile, loadUserData } = useContext(UserProfileContext);
  const { isLoggedIn, logout, loginToken } = useAuth();
  const { cartItems, clearCart } = useContext(CartContext);
  const { likedItems, clearLikedItems } = useContext(LikedProductContext);
  const Navigate = useNavigate();
  const location = useLocation();
  const [openedDrawer, setOpenedDrawer] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const {
    handleSearchSubmit,
    selectedCategory,
    setSelectedCategory,
    searchQuery,
    setSearchQuery,
    handleCategoryClick,
    handleSearchChange,
  } = useCategory();
  const { setSearchTerm } = useSearch();
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const isHomePage = location.pathname == "/";
  const drawerRef = useRef(null);
  const [scrolling, setScrolling] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 150);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (loginToken) {
      loadUserData();
    }
  }, [loginToken]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("login") === "true") {
      setShowLoginModal(true);
    }
  }, [location]);

  const toggleDrawer = () => setOpenedDrawer(!openedDrawer);

  const handleCloseDrawer = () => {
    setOpenedDrawer(false);
  };

  const handleClickOutside = useCallback((event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setOpenedDrawer(false);
    }
  }, []);

  useEffect(() => {
    if (openedDrawer) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openedDrawer, handleClickOutside]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      localStorage.setItem("scrollToProductList", "true"); // Set scroll flag before search
      handleSearchSubmit(event);
    }
  };

  const handleLogout = () => {
    logout();

    // Clear the cart and Liked items after successful order
    clearCart();
    clearLikedItems();

    Navigate("/");
    handleCloseDrawer();
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    setShowRegisterModal(true);
    setShowLoginModal(false);
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    setShowLoginModal(true);
    setShowRegisterModal(false);
  };

  const handleForgotPasswordOpen = () => {
    setShowForgotPasswordModal(true);
    setShowLoginModal(false);
  };
  const handleForgotPasswordClose = () => setShowForgotPasswordModal(false);

  const handleCategoryChange = (event) => {
    const selectedCategory = event.target.value; // Get selected category
    handleCategoryClick(selectedCategory); // Update category context and scroll
  };

  const handleDropdownLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleDropdownRegisterClick = () => {
    setShowRegisterModal(true);
  };

  return (
    <>
      <header className="bg-white px-0">
        <nav
          className={`p-2 navbar-expand-lg navbar-light bg-white border-bottom ${
            isSticky ? "sticky-navbar" : ""
          }`}
        >
          <div className="container px-0">
            <div className="row align-items-center d-lg-flex d-md-none d-none">
              <div className="col-7">
                <ul className="nav justify-content-between align-items-center">
                  <SiteLogo className="d-none d-lg-flex" />
                  <li className="nav-item d-none d-xl-flex">
                    <NavbarWithDropdown />
                  </li>
                </ul>
              </div>
              {/* Search Bar */}
              <div className="col-3">
                <div className="position-relative d-flex justify-content-start">
                  <input
                    type="text"
                    className="form-control ps-5 py-2"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    style={{
                      borderRadius: "50px",
                      border: "1px solid #B6BBC4",
                      color: "#B6BBC4",
                    }}
                  />
                  <Search
                    size={18}
                    color="#B6BBC4"
                    onClick={handleSearchSubmit}
                    className="position-absolute"
                    style={{
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>

              {/* 4th Div - Liked Items, Cart, Language Dropdown, Profile Dropdown */}
              <div className="col-2 d-flex align-items-center justify-content-between px-0">
                {/* Liked Items Icon with Badge */}
                <div className="position-relative mx-1">
                  <Link
                    to="/liked-products"
                    className="text-decoration-none ps-2"
                    style={{ color: "#00713D" }}
                  >
                    <FavoriteBorder size={30} />
                  </Link>

                  {/* Badge for liked items (always visible, even if 0) */}
                  <span
                    className="badge rounded-pill bg-green-theme"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      transform: "translate(50%, -50%)",
                      fontSize: "8px",
                      padding: "4px 6px",
                      minWidth: "18px",
                    }}
                  >
                    {likedItems.length}
                  </span>
                </div>

                {/* Cart Items Icon */}
                <div className="position-relative mx-1">
                  <Link
                    to="/cart"
                    className="text-decoration-none ps-2"
                    style={{ color: "#00713D" }}
                  >
                    <AddShoppingCart size={30} />
                  </Link>

                  {/* Badge for liked items (always visible, even if 0) */}
                  <span
                    className="badge rounded-pill bg-green-theme"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      transform: "translate(50%, -50%)",
                      fontSize: "8px",
                      padding: "4px 6px",
                      minWidth: "18px",
                    }}
                  >
                    {cartItems.length}
                  </span>
                </div>

                <div className="position-relative me-0 ms-3">
                  <LanguageSwitcher />
                </div>

                {/* Profile Dropdown */}
                <div className="dropdown mx-1">
                  <button
                    className="btn btn-light bg-transparent border-0 px-0"
                    type="button"
                    id="profileDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ color: "#00713D" }}
                  >
                    {isLoggedIn && userProfile?.profileImageUrl ? (
                      <img
                        src={userProfile.profileImageUrl}
                        alt="User Profile"
                        className="rounded-circle p-0"
                        style={{
                          width: "30px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <AccountCircle sx={{ fontSize: 30, color: "#00713D" }} />
                    )}
                  </button>

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="profileDropdown"
                  >
                    {isLoggedIn ? (
                      <>
                        <li>
                          <Link
                            to="/user-profile"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaUser className="me-2" /> Profile
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/about-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaInfoCircle className="me-2" /> About Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/contact-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaPhoneAlt className="me-2" /> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/faqs"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaQuestionCircle className="me-2" /> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/terms&condition"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaFileContract className="me-2" /> Terms &
                            Conditions
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/refund-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaExchangeAlt className="me-2" /> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/return-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaUndo className="me-2" /> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/ask-a-questions"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaHeadset className="me-2" /> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/user-profile"
                            state={{ activeComponent: "my-orders" }}
                            rel="noopener noreferrer"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaShoppingBag className="me-2" />{" "}
                            {t("Track-Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/happy-customers"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaSmile className="me-2" /> Happy Customers
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"
                            onClick={handleLogout}
                            className="dropdown-item text-danger d-flex align-items-center"
                          >
                            <FaSignOutAlt className="me-2" /> Logout
                          </Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <Link
                            to="#"
                            onClick={handleDropdownLoginClick}
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaSignInAlt className="me-2" /> Login
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/about-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaInfoCircle className="me-2" /> About Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/contact-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaPhoneAlt className="me-2" /> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/faqs"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaQuestionCircle className="me-2" /> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/terms&condition"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaFileContract className="me-2" /> Terms &
                            Conditions
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/refund-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaExchangeAlt className="me-2" /> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/return-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaUndo className="me-2" /> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/ask-a-questions"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaHeadset className="me-2" /> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/user-profile"
                            state={{ activeComponent: "my-orders" }}
                            rel="noopener noreferrer"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaShoppingBag className="me-2" />{" "}
                            {t("Track-Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/happy-customers"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaSmile className="me-2" /> Happy Customers
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"
                            onClick={handleDropdownRegisterClick}
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaUserPlus className="me-2" /> Sign Up
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="row d-lg-none d-md-flex d-flex px-2 align-items-center justify-content-between">
              {/* Logo on Left */}
              <div className="col-6">
                <SiteLogo />
              </div>

              {/* Icons + Hamburger on Right */}
              <div className="col-6 d-flex justify-content-end align-items-center">
                {/* Liked Items Icon */}
                <div className="position-relative mx-1">
                  <Link
                    to="/liked-products"
                    className="text-decoration-none ps-2"
                    style={{ color: "#00713D" }}
                  >
                    <FavoriteBorder size={30} />
                  </Link>

                  {/* Badge for liked items (always visible, even if 0) */}
                  <span
                    className="badge rounded-pill bg-green-theme"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      transform: "translate(50%, -50%)",
                      fontSize: "8px",
                      padding: "4px 6px",
                      minWidth: "18px",
                    }}
                  >
                    {likedItems.length}
                  </span>
                </div>

                {/* Cart Icon */}
                <div className="position-relative mx-1">
                  <Link
                    to="/cart"
                    className="text-decoration-none ps-2"
                    style={{ color: "#00713D" }}
                  >
                    <AddShoppingCart size={30} />
                  </Link>

                  {/* Badge for liked items (always visible, even if 0) */}
                  <span
                    className="badge rounded-pill bg-green-theme"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      transform: "translate(50%, -50%)",
                      fontSize: "8px",
                      padding: "4px 6px",
                      minWidth: "18px",
                    }}
                  >
                    {cartItems.length}
                  </span>
                </div>

                {/* Profile Dropdown */}
                <div className="dropdown ms-2">
                  <button
                    className="btn btn-light bg-transparent border-0 px-0"
                    type="button"
                    id="profileDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ color: "#00713D" }}
                  >
                    {isLoggedIn && userProfile?.profileImageUrl ? (
                      <img
                        src={userProfile.profileImageUrl}
                        alt="User Profile"
                        className="rounded-circle p-0"
                        style={{
                          width: "30px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <AccountCircle sx={{ fontSize: 30, color: "#00713D" }} />
                    )}
                  </button>

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="profileDropdown"
                  >
                    {isLoggedIn ? (
                      <>
                        <li>
                          <Link
                            to="/user-profile"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaUser className="me-2" /> Profile
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/about-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaInfoCircle className="me-2" /> About Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/contact-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaPhoneAlt className="me-2" /> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/faqs"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaQuestionCircle className="me-2" /> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/terms&condition"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaFileContract className="me-2" /> Terms &
                            Conditions
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/refund-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaExchangeAlt className="me-2" /> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/return-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaUndo className="me-2" /> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/ask-a-questions"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaHeadset className="me-2" /> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/user-profile"
                            state={{ activeComponent: "my-orders" }}
                            rel="noopener noreferrer"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaShoppingBag className="me-2" />{" "}
                            {t("Track-Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/happy-customers"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaSmile className="me-2" /> Happy Customers
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"
                            onClick={handleLogout}
                            className="dropdown-item text-danger d-flex align-items-center"
                          >
                            <FaSignOutAlt className="me-2" /> Logout
                          </Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <Link
                            to="#"
                            onClick={handleDropdownLoginClick}
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaSignInAlt className="me-2" /> Login
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/about-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaInfoCircle className="me-2" /> About Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/contact-us"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaPhoneAlt className="me-2" /> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/faqs"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaQuestionCircle className="me-2" /> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/terms&condition"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaFileContract className="me-2" /> Terms &
                            Conditions
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/refund-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaExchangeAlt className="me-2" /> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/return-policies"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaUndo className="me-2" /> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/ask-a-questions"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaHeadset className="me-2" /> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/user-profile"
                            state={{ activeComponent: "my-orders" }}
                            rel="noopener noreferrer"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaShoppingBag className="me-2" />{" "}
                            {t("Track-Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/happy-customers"
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                          >
                            <FaSmile className="me-2" /> Happy Customers
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"
                            onClick={handleDropdownRegisterClick}
                            className="dropdown-item d-flex align-items-center"
                          >
                            <FaUserPlus className="me-2" /> Sign Up
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </div>

                {/* Hamburger Menu */}
                {/* <button
                  className="btn btn-light border-0 bg-transparent ms-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                  style={{ color: "#00713D" }}
                >
                  <Menu size={30} color="#00713D" />
                </button>

                <div
                  className="offcanvas offcanvas-start"
                  tabIndex="-1"
                  id="mobileMenu"
                  aria-labelledby="mobileMenuLabel"
                >
                  <div className="offcanvas-header">
                    <button
                      type="button"
                      className="btn-close position-absolute top-0 end-0 pt-5 pe-5"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="offcanvas-body py-0">
                    <ul className="nav flex-column text-figma-green">
                      <SiteLogo className="d-flex" />
                      <hr />
                      <li className="nav-item">
                        <Link className="nav-link" to="#">
                          <MobileLinks />
                        </Link>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/faqs")}
                        >
                          {t("FAQS")}
                        </a>
                      </li>
                      <li className="nav-item d-lg-none">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/terms&condition")}
                        >
                          {t("Terms & Conditions")}
                        </a>
                      </li>
                      <li className="nav-item d-lg-none">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/refund-policies")}
                        >
                          {t("Refund Policies")}
                        </a>
                      </li>
                      <li className="nav-item d-lg-none">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/return-policies")}
                        >
                          {t("Return Policies")}
                        </a>
                      </li>
                      <li className="nav-item d-lg-none">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/ask-a-questions")}
                        >
                          {t("Support Center")}
                        </a>
                      </li>
                      <li className="nav-item d-lg-none">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/happy-customers")}
                        >
                          {t("Happy-Customers")}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/about-us")}
                        >
                          About Us
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          onClick={() => handleNavigation("/contact-us")}
                        >
                          Contact Us
                        </a>
                      </li>
                      <div className="nav-item px-3">
                        <LanguageSwitcher />
                      </div>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Mobile Search Bar */}
            <div className="row d-lg-none d-md-flex d-flex px-2 mt-2 justify-content-center">
              <div className="col-12">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control ps-5 py-2"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    style={{
                      borderRadius: "50px",
                      border: "1px solid #B6BBC4",
                      color: "#B6BBC4",
                    }}
                  />
                  <Search
                    size={18}
                    color="#B6BBC4"
                    className="position-absolute"
                    onClick={handleSearchSubmit}
                    style={{
                      left: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <LoginModel
        handleRegisterClick={handleRegisterClick}
        showLoginModal={showLoginModal}
        handleCloseModal={() => setShowLoginModal(false)}
        handleForgotPasswordOpen={handleForgotPasswordOpen}
      />
      <RegisterModal
        handleLoginClick={handleLoginClick}
        showRegisterModal={showRegisterModal}
        handleCloseModal={() => setShowRegisterModal(false)}
      />

      {showForgotPasswordModal && (
        <ForgotPasswordModel
          key={showForgotPasswordModal}
          show={showForgotPasswordModal}
          handleClose={handleForgotPasswordClose}
        />
      )}
    </>
  );
};

export default HeaderFigma;
